/**
 * Resolve a league icon value to a displayable emoji.
 * Legacy data may store text identifiers like "trophy" instead of emojis.
 * This function returns the icon if it's an emoji, or a fallback otherwise.
 */
export const resolveLeagueIcon = (
  icon: string | undefined | null,
  fallback = '🏆'
): string => {
  if (!icon) return fallback;
  // If the string is only ASCII letters, it's a legacy text identifier
  if (/^[a-zA-Z]+$/.test(icon)) return fallback;
  return icon;
};
